module.exports = __webpack_public_path__ + "static/media/rhodes_0030_standardlife.0accf1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0030_standardlife.jpg
// module id = 184
// module chunks = 0